import { render, staticRenderFns } from "./RecommendProduct.vue?vue&type=template&id=3097be31&scoped=true&"
import script from "./RecommendProduct.vue?vue&type=script&lang=js&"
export * from "./RecommendProduct.vue?vue&type=script&lang=js&"
import style0 from "./RecommendProduct.vue?vue&type=style&index=0&id=3097be31&prod&lang=scss&scoped=true&"
import style1 from "./RecommendProduct.vue?vue&type=style&index=1&id=3097be31&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3097be31",
  null
  
)

export default component.exports